import React from "react";
import { Auth } from "aws-amplify";
import IconForApp from "../icons/IconForApp";
import { useMobile } from "../utils/hooks";
import { OwcButton, OwcDoubleGlobalArea, OwcIconButton, OwcTypography } from "@one/react";
import { Link } from "@mui/material";

const POST_LOGIN_REDIRECT_URL_KEY = "post_login_redirect_url";

const storePostLoginRedirectUrl = () => {
  try {
    const fullPath = `${window.location.pathname}${window.location.search || ""}${window.location.hash || ""}`;
    sessionStorage.setItem(POST_LOGIN_REDIRECT_URL_KEY, fullPath);
    localStorage.setItem(POST_LOGIN_REDIRECT_URL_KEY, fullPath);
  } catch (error) {
    console.warn("Unable to persist post-login redirect URL", error);
  }
};

const CustomLink = ({ children, disabled, ...props }) => (
  <Link
    onClick={() => {
      if (disabled !== true) {
        storePostLoginRedirectUrl();
        if (process.env.REACT_APP_COGNITO_LOGIN_ENABLED?.trim()?.toUpperCase() !== "TRUE") {
          Auth.federatedSignIn({
            provider: process.env.REACT_APP_COGNITO_PROVIDER_ID,
          });
        } else {
          Auth.federatedSignIn();
        }
      }
    }}
    style={{
      textDecoration: "none",
    }}
    {...props}
  >
    {children}
  </Link>
);

const AppBarNotAuth = ({ disabled = false }) => {
  const isMobile = useMobile();
  const infoInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <OwcDoubleGlobalArea data-testid="app-bar-not-auth-main-page">
      <div slot="primary" style={{ justifyContent: "space-between" }}>
        <div
          style={{
            paddingLeft: "16px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconForApp />
          {!isMobile && (
            <OwcTypography variant="subtitle1" style={{ paddingLeft: 16 }}>
              Equipment Booking
            </OwcTypography>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <CustomLink disabled={disabled} data-testid="link-to-sign-in-on-button">
            <OwcButton
              data-testid="sign-in-button"
              disabled={disabled}
              variant="primary"
              style={{ marginRight: "26px" }}
            >
              Sign in
            </OwcButton>
          </CustomLink>
          <OwcIconButton
            style={{ marginRight: "26px" }}
            flat
            data-testid="help-button"
            onClick={() => infoInNewTab(process.env.REACT_APP_INFO_URL)}
            icon="circle_info"
          />
          <OwcIconButton
            flat
            type="legacy"
            style={{
              margin: "0 8px",
              color: "var(--one-color-interaction-default-brand-1)",
              width: "48px",
            }}
            icon="roche_logo"
          />
        </div>
      </div>
    </OwcDoubleGlobalArea>
  );
};

export default AppBarNotAuth;
